import React, { useState } from 'react'
import { Paper, Dialog, Stack, Typography, Link } from '@mui/material'
import { useTranslation } from '../../common/hooks/helper/useTranslation'
import { Link as RouterLink } from 'react-router-dom'
import { PrivacyStatementButtons } from './PrivacyStatementButtons'

export const PrivacyStatementModal: React.FC = () => {
  const [open, setOpen] = useState(true)
  const { t } = useTranslation()

  const closeModal = () => setOpen(false)

  return (
    <Dialog open={open} disableEscapeKeyDown>
      <Paper elevation={3}>
        <Stack p={3}>
          <Stack pr={3} mb={6} spacing={2}>
            <Typography variant="h6">
              {t('common:privacyStatementModal.title')}
            </Typography>
            <Typography variant="body1">
              {t('common:privacyStatementModal.description')}
            </Typography>

            <Link
              component={RouterLink}
              to="/privacy-statement"
              underline="hover"
              onClick={closeModal}
            >
              <Typography variant="body1">
                {t('common:privacyStatementModal.detailsButton')}
              </Typography>
            </Link>
          </Stack>

          <PrivacyStatementButtons onClose={closeModal} />
        </Stack>
      </Paper>
    </Dialog>
  )
}
